import { useTranslation } from 'react-i18next';
import React, { useContext, useState, useEffect } from "react"
import ListComponent from "@/components/listComponent"
import { MyContext } from "@/store/myContext"
import Detail from "./detail"
import { Modal, Select } from "antd"
import { quotaSettlePage, deleteQuotaSettle, quotaOrderDetaiUpdate } from "@/service/teamService"
import TopSearch from "@/components/TopSearch"
import { teamInvoiceStatus } from "@/utils/enum"
import Settlement from "./settlement.jsx"
const { Option } = Select
export default () => {
    
const { t } = useTranslation();
const { state, message } = useContext(MyContext)
    const [showVisible, setShowVisible] = useState(false)
    const [list, setList] = useState([]) //列表
    const [searchValue, setSearchValue] = useState({})
    const [pagination, setpagination] = useState({
        //分页配置
        total: 0,
        current: 1,
        pageSize: 10,
    })
    const [selectInfo, setSelectInfo] = useState({ rowInfo: {}, rowIndex: -1 }) //记录当前行下标及信息
    const [settleVisible, setSettlevisible] = useState(false)

    useEffect(() => {
        if (state.activeMenu === "teamUnsettleds") {
            loadData(pagination.current)
        }
    }, [state.activeMenu]) // eslint-disable-line react-hooks/exhaustive-deps

    //列表数据
    const loadData = (current, search = {}) => {
        let data = {
            searchItem: { settlementStatus: 1, ...search },
            pageNum: current,
            pageSize: 10,
            orders: [
                {
                    column: "settlement_time",
                    rule: "DESC",
                },
            ],
        }
        quotaSettlePage(data).then((res) => {
            setpagination({
                current: current,
                total: res.retData.total,
                pageSize: 10,
            })
            setSelectInfo({ rowInfo: {}, rowIndex: -1 })
            setList(res.retData.list)
        })
    }
    //分页事件 置空当前行信息
    const onTableChange = async (page) => {
        await setpagination({
            ...pagination,
            current: page.current,
        })
        loadData(page.current, searchValue)
    }

    //列表button
    const topButtons = [
        {
            click: () => {
                setSettlevisible(true)
            },
            content: t(`orderManage.team.teamUnsettleds.结算`),
        },
        {
            click: () => {
                setShowVisible(true)
            },
            content: t(`orderManage.team.teamUnsettleds.账单明细`),
        },
        {
            click: () => handleDelete(),
            content: t(`orderManage.team.teamUnsettleds.删除`),
        },
    ]

    //删除
    const handleDelete = async () => {
        if (!Object.keys(selectInfo.rowInfo).length) {
            message.warning(t(`orderManage.team.teamUnsettleds.请选择你要删除的结算单`))
            return
        }
        Modal.confirm({
            content: `${t(`orderManage.team.teamUnsettleds.确定要删除结算单`)}${selectInfo.rowInfo.settlementNo}?`,
            okText: t(`orderManage.team.teamUnsettleds.确定`),
            cancelText: t(`orderManage.team.teamUnsettleds.取消`),
            centered: true,
            onOk() {
                deleteQuotaSettle(selectInfo.rowInfo.id).then((res) => {
                    message.success(t(`orderManage.team.teamUnsettleds.删除成功`))
                    loadData(pagination.current, searchValue)
                })
            },
        })
    }

    const handleChangeInvoiceStatus = (id) => {
        let invoiceStatus = ""
        Modal.confirm({
            title: t(`orderManage.team.teamUnsettleds.请选择开票状态`),
            content: (
                <Select style={{ width: 240 }} placeholder= {t(`orderManage.team.teamUnsettleds.请选择开票状态`)} onChange={(val) => {
                    invoiceStatus = val
                }}>
                    {Object.entries(teamInvoiceStatus).map((item) => (
                        <Option value={item[0]} key={item[0]}>
                            {item[1]}
                        </Option>
                    ))}
                </Select>
            ),
            okText: t(`orderManage.team.teamUnsettleds.确定`),
            cancelText: t(`orderManage.team.teamUnsettleds.取消`),
            onOk: () => {
                return new Promise((resolve, reject) => {
                    if (invoiceStatus) {
                        resolve(Number(invoiceStatus))
                    } else {
                        message.warning(t(`orderManage.team.teamUnsettleds.请选择发票状态`))
                        reject(t(`orderManage.team.teamUnsettleds.请选择发票状态`))
                    }
                }).then((res) => {
                    let data = {
                        invoiceStatus: res,
                        id
                    }
                    quotaOrderDetaiUpdate(data).then((res) => {
                        loadData(1, searchValue)
                        message.success(`${t(`orderManage.team.teamUnsettleds.发票状态更新成功`)}！`)
                       
                    })
                })
            },
            onCancel: () => {},
        })
    }

    //table配置
    const columns = [
        {
            title: t(`orderManage.team.teamUnsettleds.账单编号`),
            align: "center",
            dataIndex: "settlementNo",
        },
        {
            title: t(`orderManage.team.teamUnsettleds.团队名称`),
            align: "center",
            dataIndex: "teamName",
        },
        {
            title: t(`orderManage.team.teamUnsettleds.工单数量`),
            align: "center",
            dataIndex: "orderNum",
        },
        {
            title: t(`orderManage.team.teamUnsettleds.账单金额`),
            align: "center",
            dataIndex: "totalAmount",
        },
        {
            title: t(`orderManage.team.teamUnsettleds.业务经理`),
            align: "center",
            dataIndex: "managerName",
        },
        {
            title: t(`orderManage.team.teamUnsettleds.账单类型`),
            align: "center",
            dataIndex: "settlementMethod",
        },
        {
            title: t(`orderManage.team.teamUnsettleds.出账日期`),
            align: "center",
            dataIndex: "settlementTime",
        },
        {
            title: t(`orderManage.team.teamUnsettleds.是否打款`),
            align: "center",
            dataIndex: "settlementStatus",
            // render: (text) => (text === 0 ? "未打款" : "已打款"),
            render: (text) => (text === 1 ? t(`orderManage.team.teamUnsettleds.未打款`) : t(`orderManage.team.teamUnsettleds.已打款`)),
        },
        {
            title: t(`orderManage.team.teamUnsettleds.发票`),
            align: "center",
            dataIndex: "invoiceStatus",
            render: (text, record) => (
                <>
                    <span>{teamInvoiceStatus[text]}</span>
                    <span style={{ color: "#2e3aeb", cursor: "pointer", marginLeft: "10px" }} onClick={() => {handleChangeInvoiceStatus(record.id)}}>
                         {t(`orderManage.team.teamUnsettleds.操作`)}
                    </span>
                </>
            ),
        },
    ]
    // 搜索JSON
    const searchList = {
        normalList: [
            {
                type: "input",
                placeholder: t(`orderManage.team.teamUnsettleds.团队名称`),
                valueName: "teamName",
            },
            {
                type: "select",
                placeholder: t(`orderManage.team.teamUnsettleds.请选择开票状态`),
                valueName: "invoiceStatus",
                optionList: () =>
                    Object.entries(teamInvoiceStatus).map((item) => (
                        <Option value={item[0]} key={item[0]}>
                            {item[1]}
                        </Option>
                    )),
            },
        ],
    }

    return (
        <>
            {state.activeMenu === "teamUnsettleds" && (
                <>
                    <TopSearch
                        title= {t(`orderManage.team.teamUnsettleds.未结算`)}
                        searchListData={searchList}
                        searchValue={searchValue}
                        setSearchValue={(obj) => setSearchValue(obj)}
                        handleSearch={loadData}
                    />
                    <ListComponent
                        title= {t(`orderManage.team.teamUnsettleds.未结算`)}
                        buttons={topButtons}
                        selectInfo={selectInfo}
                        columns={columns}
                        dataSource={list}
                        pagination={pagination}
                        onTableChange={onTableChange}
                        setSelectInfo={(obj) => setSelectInfo(obj)}
                        scroll={{ x: "max-content" }}
                    />

                    {showVisible && <Detail rowInfo={selectInfo.rowInfo} visible={showVisible} setVisible={setShowVisible} setSettlevisible={setSettlevisible} />}

                    {settleVisible && <Settlement rowInfo={selectInfo.rowInfo} visible={settleVisible} setVisible={setSettlevisible} onSuccess={() => {
                                loadData(1)
                            }} />}
                </>
            )}
        </>
    )
}
